const CognitoConfig = {
  Auth: {
    Cognito: {
      userPoolClientId: '6ldms2ci0pb479c4qcpdpjoit3',
      userPoolId: 'eu-central-1_Eu6h6OtV0',
    }
  }
};

export default CognitoConfig;
